import { blockCheckout, unblockCheckout } from './checkoutUtils';
var $ = jQuery;
export default function storeCreditEvents() {
    $(document.body).on('click', '.acfw-redeem-store-credit-form-field .button', applyStoreCredits);
}
export function applyStoreCredits() {
    // @ts-ignore
    var $button = $(this);
    var $form = $button.closest('.acfw-redeem-store-credit-form-field');
    var $input = $form.find('input.input-text');
    var amount = parsePrice($input.val());
    $form.find('p.invalid-message').remove();
    $('.woocommerce-NoticeGroup-updateOrderReview').remove();
    if (!validatePrice(amount)) {
        $form.append("<p class='invalid-message'>".concat(acfwfCheckout.enter_valid_price, "</p>"));
        return;
    }
    blockCheckout();
    $.post(wc_checkout_params.ajax_url, {
        action: 'acfwf_redeem_store_credits',
        amount: amount,
        wpnonce: acfwfCheckout.redeem_nonce,
    }, function (response) {
        unblockCheckout();
        $input.val('');
        $(document.body).trigger('update_checkout', {
            update_shipping_method: false,
        });
    });
}
function parsePrice(value) {
    return value
        ? parseFloat(value.replace(acfwfCheckout.thousand_separator, '').replace(acfwfCheckout.decimal_separator, '.'))
        : 0;
}
function validatePrice(value) {
    value = value.toString();
    var regex = new RegExp("[^-0-9%\\.]+", 'gi');
    var decimalRegex = new RegExp("[^\\.}\"]", 'gi');
    var newvalue = value.replace(regex, '');
    // Check if newvalue have more than one decimal point.
    if (1 < newvalue.replace(decimalRegex, '').length) {
        newvalue = newvalue.replace(decimalRegex, '');
    }
    return parseFloat(value) === parseFloat(newvalue);
}
